import { ProjectImage } from "@/components/molecules/project/project-image";

interface ProjectHeroImageProps {
  /** Project the image belongs to; needed to sign the URL. */
  projectId?: string | null;
  /** Storage key of the project image (`project.image`). */
  imageKey?: string | null;
  /** Alt text for the image */
  alt: string;
  /**
   * Hoogte van de hero, als CSS-lengte. Dit is de enige plek in de app waar de hoogte niet uit de
   * breedte volgt, dus de aanroeper moet er een 16:9-waarde in stoppen — zie
   * {@link HERO_IMAGE_HEIGHT}.
   */
  height: string;
  /** Children to render on top of the image (e.g., header buttons) */
  children?: React.ReactNode;
}

/**
 * Fixed background hero image for project detail pages. Stays in place while content scrolls over
 * it.
 *
 * Tot app#785 was dit een band met een VASTE hoogte van 300px over de volle breedte. Op een
 * telefoon van 393pt is dat ongeveer 1,3:1 tegen een bestand van 16:9, dus sneed hij er links en
 * rechts een kwart af — het enige kader in de app dat dat nog deed, en precies waarom er een
 * focuspunt bestond. De hoogte volgt nu de breedte, dus er valt niets meer af.
 */
export function ProjectHeroImage({
  projectId,
  imageKey,
  alt,
  height,
  children,
}: ProjectHeroImageProps) {
  return (
    <div className="pointer-events-none fixed left-0 right-0 top-0 z-0 w-full" style={{ height }}>
      <ProjectImage projectId={projectId} imageKey={imageKey} alt={alt} className="h-full w-full" />
      <div className="pointer-events-auto">{children}</div>
    </div>
  );
}
